import type { PayinsTranslations } from "@/shared/lang/interfaces/payins";

import { PayinRail } from "../services/paymentsPayin.service";
import type { PayinCountry } from "../types/payins.types";

export interface PayinCountryConfig {
  /** ISO3 code — matches the payments-runtime `country` field. */
  code: PayinCountry;
  /** ISO2 code (lowercase) for flag rendering. */
  iso2: string;
  /** ISO 4217 currency of the payin amounts. */
  currency: string;
  /** Rail the runtime executes this corridor on — the key the corridor catalog is queried by. */
  rail: PayinRail;
  /** Translation key in the `payins` namespace. */
  labelKey: keyof PayinsTranslations;
}

/**
 * Catalog of countries with payin support — drives the /app/payins creation tabs and flags. Exactly the
 * corridors the payments runtime executes (USA rode the legacy PHP proxy and was retired with it).
 */
export const PAYIN_COUNTRIES: PayinCountryConfig[] = [
  { code: "BRA", iso2: "br", currency: "BRL", rail: PayinRail.PIX, labelKey: "country_BRA" },
  { code: "COL", iso2: "co", currency: "COP", rail: PayinRail.BREB, labelKey: "country_COL" },
  { code: "MEX", iso2: "mx", currency: "MXN", rail: PayinRail.SPEI, labelKey: "country_MEX" },
  { code: "ARG", iso2: "ar", currency: "ARS", rail: PayinRail.CBU_CVU, labelKey: "country_ARG" },
];

export const PAYIN_COUNTRY_BY_CODE = new Map(PAYIN_COUNTRIES.map((country) => [country.code, country]));

// Polling interval for the payin status (in milliseconds)
export const PAYIN_POLLING_INTERVAL = 5000;
